/* eslint-disable no-console */

/* Main entry point */
import 'whatwg-fetch';
import '@babel/polyfill';
import Vue from 'vue';
import './plugins/vuetify'; // Imports and 'uses' vuetify in project
import App from './App.vue';
import router from './router';
import store from './store/index.js';
import { userHandler } from '@/services/api';

Vue.config.productionTip = false;

fetch(`/api/status/environment`)
  .then(async (response) => {
    if ((response || null) !== null) {
      if (response.status === 200) {
        response.text().then((env) => {
          localStorage.setItem('environment', env);
        });
      }
      finishSetup();
    } else {
      finishSetup();
    }
  });

const finishSetup = () => {
  // Renew existing token
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const ssoParam = urlParams.get('sso');

    if ((ssoParam || null) !== null) {
      userHandler.sso(decodeURIComponent(ssoParam))
        .then((rs) => {
          var newurl = '';
          if (rs.code === 0) {
            newurl = window.location.protocol + '//' + window.location.host + window.location.pathname;
            window.history.pushState({ path: newurl }, '', newurl);
            setupApp();
          } else {
            newurl = window.location.protocol + '//' + window.location.host;
            window.history.pushState({ path: newurl }, '', newurl);
            setupApp();
          }
        }).catch((e) => {
          var newurl = window.location.protocol + '//' + window.location.host;
          window.history.pushState({ path: newurl }, '', newurl);
          setupApp();
        });
    } else {
      setupApp();
    }
  } catch (ex) {
    setupApp();
  }
};

const setupApp = () => {
  // Do not create new app until we have renewed existing token.
  // This causes the route guard to come into effect, and will route to unauthorized if userPermissions not yet set into store.
  var app = new Vue({
    router,
    store,
    render: h => h(App)
  });

  app.$mount('#status');

  return app;
};
